import "../css/Pragmatica.css";

export const getDesignTokens = (mode) => ({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    h4: {
      fontFamily: "Pragmatica, sans-serif",
    },
    h5: {
      fontFamily: "Pragmatica, sans-serif",
    },
    h6: {
      fontFamily: "Pragmatica, sans-serif",
    },
    h7: {
      fontFamily: "Pragmatica, sans-serif",
    },
    body1: {
      fontFamily: "Pragmatica, sans-serif",
      fontWeight: 300,
      fontSize: "1.1rem",
      lineHeight: "1.3",
    },
    body2: {
      fontFamily: "Pragmatica, sans-serif",
      fontWeight: 300,
      fontSize: "1.1rem",
      lineHeight: "1.3",
      marginBottom: "0.75rem",
    },
    caption: {
      fontFamily: "Pragmatica, sans-serif",
      fontWeight: 600,
      fontSize: "0.625rem",
      lineHeight: "1.3",
    },
  },
  shape: {
    borderRadius: 10,
  },
  palette: {
    mode,
    ...(mode === "light"
      ? {
          primary: {
            main: "#F4976C",
            light: "#ffca36",
            contrastText: "#FFF",
          },
          secondary: {
            main: "#B4DFE5",
            light: "#D2FDFF",
          },
          background: {
            default: "#FEFCFB",
            paper: "#FEFCFB",
          },
          text: {
            primary: "#303C6C",
          },
        }
      : //Dark Mode
        {
          primary: {
            main: "#0de5b2",
          },
          secondary: {
            main: "#2b45ed",
          },
          background: {
            default: "#131854",
            paper: "#131854",
          },
          text: {
            primary: "#FEFCFB",
          },
        }),
  },
});

export const getThemedComponents = (mode) => ({
  components: {
    // Both Modes
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input": {
            "&:-webkit-autofill": {
              transition:
                "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
            },
          },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          fontSize: "1.3rem",
          lineHeight: "1.75rem",
          fontWeight: 500,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& > fieldset > legend": {
            fontSize: `calc(0.75 * 1.3rem)`,
            fontWeight: 400,
          },
        },
      },
    },
    MuiRichTreeView: {
      styleOverrides: {
        root: {
          "& .MuiTreeItem-label": {
            fontSize: "1rem!important",
          },
        },
      },
    },
    // Customize Links to appear as Chips
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
      styleOverrides: {
        root: {
          display: 'inline-flex',
          alignItems: 'center',
          padding: '4px 8px',
          borderRadius: '16px',
          backgroundColor: mode === 'light' ? '#F4976C' : '#0de5b2',
          color: mode === 'light' ? '#FFF' : '#131854',
          fontWeight: 500,
          fontSize: '0.875rem',
          transition: 'background-color 0.3s ease',
          cursor: 'pointer',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: mode === 'light' ? '#e58a5f' : '#0bc89d',
            textDecoration: 'none',
          },
          '&:focus': {
            outline: 'none',
            boxShadow: mode === 'light' ? '0 0 0 2px rgba(244, 151, 108, 0.5)' : '0 0 0 2px rgba(13, 229, 178, 0.5)',
          },
        },
      },
    },
  },
});
